var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("crudOperation", { attrs: { permission: _vm.permission } }),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 12, offset: 10 } }, [
            _c(
              "span",
              [
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      size: "mini",
                      type: "success",
                      icon: "el-icon-search",
                    },
                    on: { click: _vm.crud.toQuery },
                  },
                  [_vm._v("搜索")]
                ),
                _vm._v(" "),
                _vm.crud.optShow.reset
                  ? _c(
                      "el-button",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          size: "mini",
                          type: "warning",
                          icon: "el-icon-refresh-left",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.resetQuery()
                          },
                        },
                      },
                      [_vm._v("重置")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              staticStyle: {
                float: "left",
                "margin-bottom": "15px",
                "margin-top": "15px",
              },
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.showSearchItem()
                },
              },
            },
            [_vm._v("高级筛选")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "before-close": _vm.crud.cancelCU,
            visible: _vm.crud.status.cu > 0,
            title: _vm.crud.status.title,
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.crud.status, "cu > 0", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                size: "small",
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "370px" },
                  attrs: { label: "报表名称", prop: "reportName" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "370px" },
                    model: {
                      value: _vm.form.reportName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reportName", $$v)
                      },
                      expression: "form.reportName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否为存储过程" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isStoredProcedure,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isStoredProcedure", $$v)
                        },
                        expression: "form.isStoredProcedure",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "是" } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "否" } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.isStoredProcedure === "是"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "是否分页" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.isPage,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "isPage", $$v)
                            },
                            expression: "form.isPage",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "是" } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: "否" } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "是否传入用户id" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.form.isUserId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "isUserId", $$v)
                        },
                        expression: "form.isUserId",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "是" } }, [
                        _vm._v("是"),
                      ]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: "否" } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "370px" },
                  attrs: { label: "sql语句", prop: "sqlStatement" },
                },
                [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.sqlStatement,
                        expression: "form.sqlStatement",
                      },
                    ],
                    staticStyle: { width: "370px" },
                    domProps: { value: _vm.form.sqlStatement },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.form, "sqlStatement", $event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "text" }, on: { click: _vm.crud.cancelCU } },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.crud.status.cu === 2, type: "primary" },
                  on: { click: _vm.crud.submitCU },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.addFieldVisible,
            title: "增加字段",
            width: "400px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addFieldVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "addFieldForm",
              attrs: {
                model: _vm.addFieldForm,
                rules: _vm.addFieldRules,
                size: "small",
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "字段列名", prop: "title" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addFieldForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFieldForm, "title", $$v)
                      },
                      expression: "addFieldForm.title",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "字段描述" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.addFieldForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.addFieldForm, "name", $$v)
                      },
                      expression: "addFieldForm.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      _vm.addFieldVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmAddField },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.drawer,
            title: "编辑字段",
            width: "1300px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "el-card",
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "10px" },
                  attrs: { type: "text", icon: "el-icon-plus", size: "mini" },
                  on: { click: _vm.openAddFieldDialog },
                },
                [_vm._v("增加字段")]
              ),
              _vm._v(" "),
              _c(
                "el-table",
                { ref: "dragTable", attrs: { data: _vm.titleData } },
                [
                  _c("el-table-column", {
                    attrs: { label: "排序", width: "50", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("i", {
                              staticClass: "el-icon-rank drag-handle",
                              staticStyle: {
                                cursor: "move",
                                "font-size": "16px",
                                color: "#999",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", width: "60", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                staticStyle: { color: "#F56C6C" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.delField(scope.$index)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "字段列名",
                      prop: "title",
                      "min-width": "10%",
                      "show-overflow-tooltip": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "字段描述", "min-width": "10%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.name,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "name", $$v)
                                },
                                expression: "scope.row.name",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "字段类型", "min-width": "11%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                model: {
                                  value: scope.row.type,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "type", $$v)
                                  },
                                  expression: "scope.row.type",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "String", value: "String" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "Integer", value: "Integer" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "Date", value: "Date" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: {
                                    label: "DateTime",
                                    value: "DateTime",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "显示", "min-width": "4%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: { "true-label": "1", "false-label": "0" },
                              model: {
                                value: scope.row.show,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "show", $$v)
                                },
                                expression: "scope.row.show",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "查询", "min-width": "3%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: { "true-label": "1", "false-label": "0" },
                              model: {
                                value: scope.row.query,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "query", $$v)
                                },
                                expression: "scope.row.query",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "查询排序", "min-width": "6%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "", placeholder: "无" },
                                on: {
                                  change: function ($event) {
                                    return _vm.onOrderByChange(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.orderBy,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "orderBy", $$v)
                                  },
                                  expression: "scope.row.orderBy",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "升序", value: "asc" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { label: "降序", value: "desc" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "是否穿透", "min-width": "5%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-checkbox", {
                              attrs: { "true-label": "1", "false-label": "0" },
                              model: {
                                value: scope.row.penetrate,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "penetrate", $$v)
                                },
                                expression: "scope.row.penetrate",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "子报表id", "min-width": "10%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.subreport,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "subreport", $$v)
                                },
                                expression: "scope.row.subreport",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "子报表参数", "min-width": "10%" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-input", {
                              model: {
                                value: scope.row.subreportParams,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "subreportParams", $$v)
                                },
                                expression: "scope.row.subreportParams",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form",
                { attrs: { "label-width": "100px" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "margin-left": "-100px",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm()
                            },
                          },
                        },
                        [_vm._v("提交")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "table-content" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.crud.loading,
                  expression: "crud.loading",
                },
                {
                  name: "sticky",
                  rawName: "v-sticky",
                  value: { top: 0 },
                  expression: "{ top: 0 }",
                },
              ],
              staticClass: "sticky-head",
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                data: _vm.crud.data,
                "header-cell-style": {
                  background: "#f6f7fa",
                  color: "#606266",
                },
                "max-height": "800",
              },
            },
            [
              _vm._l(_vm.cities, function (col) {
                return _c("el-table-column", {
                  attrs: {
                    prop: col.prop,
                    label: col.label,
                    "min-width": col.width ? col.width : 120,
                    "render-header": _vm.render,
                    "show-overflow-tooltip": true,
                    "column-key": col.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            col.prop1 != undefined
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      Array.isArray(
                                        scope.row[col.prop1][col.prop2]
                                      )
                                        ? JSON.parse(
                                            scope.row[col.prop1][col.prop2]
                                          ).toString()
                                        : scope.row[col.prop1][col.prop2] || "-"
                                    )
                                  ),
                                ])
                              : col.type === "select" && scope.row[col.prop]
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row[col.prop].indexOf("[") > -1
                                        ? JSON.parse(
                                            scope.row[col.prop]
                                          ).toString()
                                        : scope.row[col.prop].toString()
                                    )
                                  ),
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(scope.row[col.prop] || "-")),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "220" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: { float: "left" },
                            attrs: { align: "left" },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEditTable(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑字段")]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { align: "center" } },
                          [
                            _c("udOperation", {
                              attrs: {
                                data: scope.row,
                                permission: _vm.permission,
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }